import React from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import '../Assets/Css/about.css';
import aboutbanner from '../Assets/Images/aboutbanner1main.jpg';
import { FaCompass, FaHandshake, FaLightbulb, FaBullseye } from "react-icons/fa";
import gemImage from '../Assets/Images/gem.jpeg';
import mstcImage from '../Assets/Images/mstc.jpeg';
// import isoImage from '../Assets/Pdf/iso-certi.pdf';
import Banner4 from '../Assets/Images/leaglelicences.avif';
import isocrt from '../Assets/Images/isocrtificate.png';
import consentImage from '../Assets/Images/Certi3.png';

import Aboutbanner from '../Assets/Images/Aboutbanner1.avif'
import Banner3 from '../Assets/Images/manufacturing.avif';

import { FaBuilding, FaBoxOpen, FaUserTie, FaCertificate } from 'react-icons/fa';
import { FaGlobeAmericas, FaIndustry, FaTruck, FaBalanceScale } from 'react-icons/fa';
import { Helmet } from 'react-helmet';




export default function About() {
  const coreValues = [
    {
      title: "Integrity",
      description: "We believe in honest, transparent, and fair business dealings.",
      icon: <FaCompass />,
    },
    {
      title: "Commitment",
      description: "We consistently strive to exceed expectations.",
      icon: <FaHandshake />,
    },
    {
      title: "Innovation",
      description: "We embrace change and continuously improve our processes and services.",
      icon: <FaLightbulb />,
    },
    {
      title: "Customer Focus",
      description: "We prioritize building long-term, value-driven relationships.",
      icon: <FaBullseye />,
    },
  ];

  const certificates = [
    { src: '/certificates/cert1.jpg', alt: 'Certificate 1' },
    { src: '/certificates/cert2.jpg', alt: 'Certificate 2' },
    { src: '/certificates/cert3.jpg', alt: 'Certificate 3' },
  ];
  return (
    <>
      <div className="mainnav">
        {/* Banner Section */}


        <Helmet>
          <title>About Us | SIDDHI INTERNATIONAL</title>
          <meta name="description" content="SIDDHI INTERNATIONAL is a fast-growing Indian enterprise engaged in Import & Export, Manufacturing, Distribution, and Legal & Licensing Consultation. We specialize in chemicals, electronics, agro products, ecommerce, and compliance services." />

          {/* Open Graph / Facebook */}
          <meta property="og:title" content="About Us | SIDDHI INTERNATIONAL" />
          <meta property="og:description" content="Empowering Global Trade with Innovation, Integrity & Excellence. Learn more about our expertise in global trade, manufacturing, distribution, and legal services." />
          <meta property="og:type" content="website" />
          <meta property="og:url" content="https://www.siddhinternational.com/about" />
          <meta property="og:image" content="https://www.siddhinternational.com/images/about-banner.jpg" />

          {/* Twitter */}
          <meta name="twitter:title" content="About Us | SIDDHI INTERNATIONAL" />
          <meta name="twitter:description" content="Your trusted partner in global trade, compliance, and quality manufacturing solutions." />
          <meta name="twitter:image" content="https://www.siddhinternational.com/images/about-banner.jpg" />
          <meta name="twitter:card" content="summary_large_image" />

          <link rel="canonical" href="https://www.siddhinternational.com/about" />
        </Helmet>


        <div className="about-banner position-relative text-white">
          <img
            src={aboutbanner}
            alt="About Banner"
            className="aboutbanner-image "
          />

          <div className="container d-flex justify-content-center align-items-center h-100">
            <div className="row w-100 justify-content-center">
              <div className="col-12 col-md-6 px-3">
                <div className="maindesc">
                  <h2 className="fw-bold">
                    Empowering Global Trade with Innovation, Integrity & Excellence
                  </h2>
                  <p className="lead">
                    Global solutions in trade, manufacturing, distribution, and legal services—driven by quality, trust, and expertise.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>


        <div className="bg-body-secondary p-4 py-5">
          <Container className='mb-4 ' >
            <Row className="text-center">
              <Col>

                <Row>
                  <Col lg={6} className='mb-3'>
                    <Row className="justify-content-center">
                      <Col lg={10} className="mb-3">
                        <img src={Aboutbanner} alt="" style={{ width: '100%', height: '200px', borderRadius: '8px' }} />
                      </Col>
                    </Row>
                    <Row className="justify-content-center g-3">
                      <Col lg={5}>
                        <img src={Banner3} alt=""
                          style={{ width: '100%', height: '200px', borderRadius: '8px' }} />
                      </Col>
                      <Col lg={5}>
                        <img src={Banner4} alt=""
                          style={{ width: '100%', height: '200px', borderRadius: '8px' }} />
                      </Col>
                    </Row>
                  </Col>


                  <Col lg={6}>
                    <h3 className="Mainhead">About Us</h3>
                    <p style={{ textAlign: 'justify' }}>
                      <b style={{ color: '#29AAE1' }}>M/s. SIDDHI INTERNATIONAL</b> is a fast-growing Indian enterprise engaged in Import & Export, Manufacturing, Distribution, and Legal & Licensing Consultation. Established in 2024, we specialize in chemicals, electronics, agro products, ecommerce trading, and compliance services, with a commitment to quality, trust, and guarantee.
                    </p>
                    <p style={{ textAlign: 'justify' }}>
                      With over 20+ years of experience, founder <b style={{ color: '#29AAE1' }}>Gajanan Mohite</b> has worked with top names in the export-import industry including Toshniwal Exports, Lotus Global, and J. N. International. Our transparent, ethical, and customer-focused approach helps businesses connect globally and grow seamlessly.
                    </p>
                    <p style={{ textAlign: 'justify' }}>
                      SIDDHI INTERNATIONAL is a non-government private proprietorship company majorly active in Manufacturing, Export-Import, and Local Trade. We deal in acids, chemicals, solvents, industrial chemical compounds, organic and inorganic chemicals, electronics and electrical goods, agricultural and agrochemical products, and ecommerce trading, along with legal and licensing services.
                    </p>

                  </Col>
                </Row>
              </Col>
            </Row>
          </Container>
        </div>

        <Container className="mb-3">
          <Row className="mb-0 align-items-center">
            <Col className="text-center py-4" >
              <h3 className="Mainhead"> Company Profile</h3>
              <p className=" fs-5 px-4 mb-2">
                <span className="fw-bold text-info">SIDDHI INTERNATIONAL</span> is a fast-growing, multi-faceted enterprise engaged in Import & Export, Manufacturing, Distribution Services, Wholesale Trade, and Legal & Licensing Consultation. Based in India, the company has carved a niche for itself in both domestic and international markets through its commitment to quality, efficiency, and customer satisfaction.
              </p>
            </Col>
          </Row>

          <Row className="mb-4">
            <Col className="text-center">
              <p className="text-muted fs-5 px-4 mb-4" style={{ fontStyle: 'italic', color: '#555' }}>
                Since its inception, <span className="fw-bold text-info">SIDDHI INTERNATIONAL</span> has strived to connect businesses across borders by offering reliable and result-driven services. With a strong foundation in global trade, the company is known for its ethical approach, transparent operations, and a customer-centric mindset.
              </p>
            </Col>
          </Row>


          <Row className="mb-2">
            <Col md={6} className="mb-4">
              <div className="section-card p-4 bg-dark rounded shadow-lg">
                <div className="section-headerr">
                  <FaGlobeAmericas className="section-iconn" />
                  <h4 className="fw-bold text-info mb-3">Global Import & Export Solutions</h4>
                </div>
                <p style={{ fontSize: '16px' }} className="text-white">
                  At the core of our operations lies our import-export division, which deals in a wide range of products including raw materials, industrial supplies, consumer goods, and agro-based commodities. Leveraging a global network of suppliers and buyers, we ensure the smooth flow of goods across continents while adhering to all international trade regulations and standards.
                </p>
              </div>
            </Col>

            <Col md={6} className="mb-3">
              <div className="section-card p-4 text-dark rounded shadow-lg">
                <div className="section-headerr">
                  <FaIndustry className="section-iconn" />
                  <h4 className="fw-bold text-info mb-3">Manufacturing Capabilities</h4>
                </div>
                <p style={{ fontSize: '16px' }} className="section-textt">
                  SIDDHI INTERNATIONAL also operates as a manufacturer, producing high-quality goods tailored to meet both local and international demands. Our production facilities are equipped with modern machinery and follow stringent quality control practices. From custom manufacturing to bulk production, we offer scalable solutions that align with our clients’ unique requirements.
                </p>
              </div>
            </Col>
          </Row>

          <Row className="mb-3">
            <Col md={6} className="mb-4">
              <div className="section-card p-4 text-dark rounded shadow-lg">
                <div className="section-headerr">
                  <FaTruck className="section-iconn" />
                  <h4 className="fw-bold text-info mb-3">Wholesale and Distribution Network</h4>
                </div>
                <p style={{ fontSize: '16px' }} className="section-textt">
                  With a robust distribution and wholesale framework, we serve a wide client base that includes retailers, wholesalers, institutions, and corporate clients. Our well-connected supply chain, strategically located warehouses, and efficient logistics partners allow us to maintain timely deliveries and optimal stock levels, ensuring uninterrupted product availability.
                </p>
              </div>
            </Col>

            <Col md={6} className="mb-4">
              <div className="section-card p-4  bg-dark rounded shadow-lg">
                <div className="section-headerr">
                  <FaBalanceScale className="section-iconn" />
                  <h4 className="fw-bold text-info mb-3">Legal & Licensing Assistance</h4>
                </div>
                <p style={{ fontSize: '16px' }} className="text-white">
                  Understanding the complexities of trade compliance, we provide expert legal and licensing services to businesses looking to navigate the regulatory landscape. Our team supports clients with documentation, import-export licenses, registrations, and other regulatory formalities, ensuring smooth and lawful operations across borders.
                </p>
              </div>
            </Col>
          </Row>
        </Container>

        <div className='mt-4'>
          <div className='p-4 mb-4 companyback' >

            <Container>
              <h3 className="Mainheadd mt-3 mb-4"><FaBuilding className="section-icon" /> Overview & Key Services</h3>

              <Row className='m-0  justify-content-center'>
                <Col md={10}>
                  <p className="section-text">

                    <span className='text-info'> SIDDHI INTERNATIONAL </span>is a Non-govt private proprietorship company, established in 2024. It is a private proprietorship establishment.
                  </p>
                </Col>
              </Row>
              <p className="section-text2" >
                SIDDHI INTERNATIONAL is majorly in the Manufacturer and EXPORT - IMPORT AND LOCAL TRADE. "ACIDS, CHEMICALS, SOLVENTS, INDUSTRIAL CHEMICALS. VARIOUS CHEMICAL COMPOUNDS. ORGANIC AND INORGANIC CHEMICALS. ELECTRONICS AND ELECTRICALS GOODS. AGRICULTURE AND AGRO CHEMICALS PRODUCTS. ECOMMERCE TRADING ETC." LEGAL AND LICENSING SERVICES. With "QUALITY TRUST AND GUARANTEE"
              </p>

              <div className="leadership-cert-section py-5">
                <Row className="align-items-center">
                  {/* Leadership - Left */}
                  <Col md={7} className="px-5 text-light text-md-start text-center">
                    <div className="mb-3 text-center">
                      <FaUserTie size={40} className="mb-2 text-secondary" />
                      <h3 className="fw-bold">Leadership</h3>
                    </div>
                    <p className="section-des">
                      Founder <span className="text-info fw-bold">Gajanan Mohite</span> brings 20+ years of experience with top export-import companies
                      <span className="d-block">(Toshniwal Exports, Lotus Global, J. N. International etc.)</span>
                    </p>
                    <p className="section-des">
                      Directors: <b className="text-white">Niranjan Gajanan Mohite</b> & <b className="text-white">Gajanan Namdeo Mohite</b>.
                    </p>
                  </Col>

                  {/* Certifications - Right */}
                  <Col md={5} className="px-5 text-light  text-center">
                    <div className="mb-3">
                      <FaCertificate size={40} className="mb-2 text-secondary" />
                      <h3 className="fw-bold">Certifications</h3>
                    </div>
                    <p className="fw-bold section-des">
                      MSME: <span className="text-info">UDYAM-MH-17-0157824</span>
                    </p>

                    <p className="fw-bold section-des">
                      GSTN: <span className="text-info">27HIAPM0237G1ZG</span>
                    </p>
                    <p className="fw-bold section-des">
                      IEC: <span className="text-info">HIAPM0237G</span>
                    </p>
                  </Col>
                </Row>
              </div>
            </Container>
          </div>
        </div>
<section className="py-5 bg-light">
  <Container>
    <h3 className="Mainhead text-center mb-5">Our Government Authorizations</h3>

    {/* GeM Certificate */}
    <Card className="mb-5 shadow-sm border-0" data-aos="fade-up">
      <Row className="align-items-center g-0">
        <Col md={6}>
          <Card.Img
            src={gemImage}
            alt="GeM Certificate"
            className="img-fluid rounded-start"
            style={{ padding: '20px', maxHeight: '350px', objectFit: 'contain' }}
          />
        </Col>
        <Col md={6}>
          <Card.Body>
            <h4 className="text-primary fw-bold">GeM Registration</h4>
            <p className="text-muted">
              Registered on the Government e-Marketplace (GeM) platform under the Indian government.
              <br />
              <strong>Seller ID:</strong> K7NA250013315526
            </p>
          </Card.Body>
        </Col>
      </Row>
    </Card>

    {/* MSTC Certificate */}
    <Card className="mb-5 shadow-sm border-0" data-aos="fade-up">
      <Row className="align-items-center g-0 flex-md-row-reverse">
        <Col md={6}>
          <Card.Img
            src={mstcImage}
            alt="MSTC Certificate"
            className="img-fluid rounded-start"
            style={{ padding: '20px', maxHeight: '350px', objectFit: 'contain' }}
          />
        </Col>
        <Col md={6}>
          <Card.Body>
            <h4 className="text-primary fw-bold">MSTC Registration</h4>
            <p className="text-muted">
              MSTC (formerly Metal Scrap Trade Corporation) is a Government of India enterprise, where
              SIDDHI INTERNATIONAL is officially registered.
              <br />
              <strong>Registration No:</strong> mstc/SIDDHI INTERNATIONAL/573743
            </p>
          </Card.Body>
        </Col>
      </Row>
    </Card>

    {/* ISO Certificate */}
    <Card className="mb-5 shadow-sm border-0" data-aos="fade-up">
      <Row className="align-items-center g-0">
        <Col md={6}>
          <Card.Img
            src={isocrt}
            alt="ISO Certificate"
            className="img-fluid rounded-start"
            style={{ padding: '20px', maxHeight: '350px', objectFit: 'contain' }}
          />
        </Col>
        <Col md={6}>
          <Card.Body>
            <h4 className="text-primary fw-bold">ISO 9001:2015 Certification</h4>
            <p className="text-muted">
              Certified for Quality Management System (QMS) across diverse sectors including chemicals,
              electronics, agro products, and ecommerce trading.
              <br />
              <strong>Certificate No:</strong> KSRQS2506651728
              <br />
              <strong>Valid Till:</strong> 28-06-2028
            </p>
            <button
  className="btn btn-outline-primary btn-sm me-2"
  onClick={() => window.open('/pdfs/iso-certi.pdf', '_blank')}
>
  View PDF
</button>


        {/* Download PDF Button */}
   <a
  href="/pdfs/iso-certi.pdf"
  download
  className="btn btn-outline-primary btn-sm"
>
  Download PDF
</a>
          </Card.Body>
        </Col>
      </Row>
    </Card>
{/* Consent to Operate Certificate */}
<Card className="mb-5 shadow-sm border-0" data-aos="fade-up">
  <Row className="align-items-center g-0">
    <Col md={6}>
      <Card.Img
        src={consentImage}
        alt="Consent to Operate Certificate"
        className="img-fluid rounded-start"
        style={{ padding: '20px', maxHeight: '350px', objectFit: 'contain' }}
      />
    </Col>
    <Col md={6}>
      <Card.Body>
        <h4 className="text-primary fw-bold">Consent to Operate</h4>
        <p className="text-muted">
          Maharashtra Pollution Control Board approval for repacking and operations under environmental laws.<br />
          <strong>Valid Until:</strong> 29/02/2028<br />
          <strong>Industry:</strong> SIDDHI INTERNATIONAL
        </p>

        {/* View PDF Button */}
<button
  className="btn btn-outline-primary btn-sm me-2"
  onClick={() => window.open('/pdfs/consent-to-operate.pdf', '_blank')}
>
  View PDF
</button>


        {/* Download PDF Button */}
   <a
  href="/pdfs/consent-to-operate.pdf"
  download
  className="btn btn-outline-primary btn-sm"
>
  Download PDF
</a>
      </Card.Body>
    </Col>
  </Row>
</Card>
 </Container>
</section>

        <Container className='mb-4'>
          <Row className="text-center">
            <Col>
              <h3 className="Mainhead">Our Core Values</h3>

            </Col>
          </Row>
          <Row className="g-1 text-center py-2">
            {coreValues.map((value, index) => (
              <Col md={3} key={index} >
                <div className="core-card h-100 glass-effect">
                  <div className="core-icon">{value.icon}</div>
                  <h5 className="fw-bold mt-2">{value.title}</h5>
                  <p>{value.description}</p>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </div>
    </>
  );
}
